import axios from "axios";
import config from "./../config";

export default {
  async upload(token, image) {
    let formData = new FormData();
    formData.append("token", token);
    formData.append("files[]", image, image.name);

    return await axios.post(`${config.endpoint}/images/upload`, formData);
  },
  async delete(token, type, id) {
    return await axios.post(`${config.endpoint}/images/delete`, {
      token,
      type,
      id
    });
  }
};
